import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedInUser } from "redux-store/user/user.slice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";

import { OC_TOKEN } from "utils/constants";
import { verifyToken } from "redux-store/auth/auth.slice";
import { tokenMessage, error } from "redux-store/auth/auth.selector";

type PropsType = {
  children?: any;
};

export default function UserAuth({ children }: PropsType) {
  const [logedIn, setLogedIn] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const tokenSuccessMessage = useSelector(tokenMessage);

  const errorMessage = useSelector(error);
  useEffect(() => {
    if (!localStorage.getItem(OC_TOKEN)) {
      setLogedIn(false);
      navigate("/");
    } else {
      dispatch(verifyToken());
    }
  }, []);

  useEffect(() => {
    if (tokenSuccessMessage === "Token is valid") {
      setLogedIn(true);

      dispatch(getLoggedInUser());
    } else if (errorMessage.message === "Token is invalid") {
      setLogedIn(false);
      navigate("/");
    }
  }, [tokenSuccessMessage, errorMessage.message]);

  return <>{logedIn && children}</>;
}
